import qs, { ParsedQs } from 'qs';
// eslint-disable-next-line import/no-unresolved
import { useLocation } from '@reach/router';

const useQueryParams = (): ParsedQs => {
    const { search } = useLocation();
    return qs.parse((search || '').replace('?', ''));
};

export default useQueryParams;
